var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 10.4134V21.5867C29.3337 26.44 26.4403 29.3334 21.587 29.3334H10.4137C8.42699 29.3334 6.77366 28.8534 5.50699 27.9334C4.94699 27.5467 4.45366 27.0534 4.06699 26.4934C3.14699 25.2267 2.66699 23.5734 2.66699 21.5867V10.4134C2.66699 5.56002 5.56033 2.66669 10.4137 2.66669H21.587C23.5737 2.66669 25.227 3.14669 26.4937 4.06669C27.0537 4.45335 27.547 4.94669 27.9337 5.50669C28.8537 6.77335 29.3337 8.42669 29.3337 10.4134Z",
    fill: "#00DED1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9331 5.50665L5.50641 27.9333C4.94641 27.5467 4.45307 27.0533 4.06641 26.4933L26.4931 4.06665C27.0531 4.45332 27.5464 4.94665 27.9331 5.50665Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 19.6666H22.4133V17.3333C22.4133 16.7866 21.96 16.3333 21.4133 16.3333C20.8667 16.3333 20.4133 16.7866 20.4133 17.3333V19.6666H18C17.4533 19.6666 17 20.12 17 20.6666C17 21.2133 17.4533 21.6666 18 21.6666H20.4133V24C20.4133 24.5466 20.8667 25 21.4133 25C21.96 25 22.4133 24.5466 22.4133 24V21.6666H24.6667C25.2133 21.6666 25.6667 21.2133 25.6667 20.6666C25.6667 20.12 25.2133 19.6666 24.6667 19.6666Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 11H7.33301C6.78634 11 6.33301 10.5467 6.33301 10C6.33301 9.45333 6.78634 9 7.33301 9H13.9997C14.5463 9 14.9997 9.45333 14.9997 10C14.9997 10.5467 14.5463 11 13.9997 11Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputing);
export default __webpack_public_path__ + "static/media/computing.28397a973f982445c12603d87fc9b3f3.svg";
export { ForwardRef as ReactComponent };